"use client";

import { useState } from "react";

type GuideHeroCase = {
  label: string;
  icon: "target" | "shield" | "zap";
  message: string;
  analysis: string;
  reply: string;
};

function TabIcon({ type }: { type: GuideHeroCase["icon"] }) {
  if (type === "shield") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 3 19 6v5c0 4.5-2.8 8-7 10-4.2-2-7-5.5-7-10V6l7-3Z" />
        <path d="m9.5 12 1.7 1.7L15 9.8" />
      </svg>
    );
  }
  if (type === "zap") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="m13 2-8 12h7l-1 8 8-12h-7l1-8Z" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="7" />
      <circle cx="12" cy="12" r="2" />
      <path d="M12 3v3" />
      <path d="M12 18v3" />
      <path d="M3 12h3" />
      <path d="M18 12h3" />
    </svg>
  );
}

export function GuideHeroDemo({ cases }: { cases: GuideHeroCase[] }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const currentCase = cases[activeIndex] ?? cases[0];

  return (
    <section className="guide-case-demo" aria-label="恋爱参谋能力示例">
      <div className="guide-case-tabs" role="tablist" aria-label="示例类型">
        {cases.map((item, index) => (
          <button
            key={item.label}
            type="button"
            role="tab"
            aria-selected={activeIndex === index}
            className={activeIndex === index ? "is-active" : ""}
            onClick={() => setActiveIndex(index)}
          >
            <TabIcon type={item.icon} />
            {item.label}
          </button>
        ))}
      </div>
      <aside className="guide-case-card">
        <div className="guide-case-phone">
          <div className="guide-case-message">
            <span>她</span>
            <p>{currentCase.message}</p>
          </div>
          <div className="guide-case-answer-row">
            <div className="guide-case-coach-avatar" aria-hidden="true">
              <svg viewBox="0 0 24 24">
                <path d="m12 3 1.7 5.2L19 10l-5.3 1.8L12 17l-1.7-5.2L5 10l5.3-1.8L12 3Z" />
                <path d="m18 15 .8 2.2L21 18l-2.2.8L18 21l-.8-2.2L15 18l2.2-.8L18 15Z" />
              </svg>
              <i />
            </div>
            <div className="guide-case-reply-stack">
              <div className="guide-case-diagnosis">
                <span>
                  <TabIcon type="target" />
                  核心诊断
                </span>
                <p>{currentCase.analysis}</p>
              </div>
              <div className="guide-case-answer">
                <span>
                  ✨ 高分回复建议：
                </span>
                <blockquote>{currentCase.reply}</blockquote>
              </div>
            </div>
          </div>
        </div>
      </aside>
    </section>
  );
}
